import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import _isEmpty from "lodash/isEmpty";
import _orderBy from "lodash/orderBy";
import _partition from "lodash/partition";
import moment from "moment";
import {
  Button,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  ListItemSecondaryAction,
  Typography,
} from "@material-ui/core";
import TogoIcon from "@material-ui/icons/DirectionsRun";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import LineItem from "components/LineItem";
import useStyles from "./styles";

const Order = ({ order: { id, to_go, created_at, line_items, customer, pickup_at }, onDone, device_id }) => {
  const classes = useStyles();
  const [visible, setVisible] = useState(true);
  const [otherOpen, setOtherOpen] = useState(false);
  const [priority_items, setPriorityItems] = useState();
  const [other_items, setOtherItems] = useState([]);

  const handleDone = async (order_id) => {
    setVisible(false);
    await onDone(order_id, created_at, pickup_at);
  };

  const handleOpen = () => {
    setOtherOpen(!otherOpen);
  };

  useEffect(() => {
    if (line_items) {
      const [priority, other] = line_items.map((x) => x.device_ids).includes(device_id)
        ? _partition(line_items, (o) => o.device_ids.includes(device_id))
        : _partition(line_items, (o) => !o.is_collapsed);

      setPriorityItems(_orderBy(priority, ["category_weight"], ["desc"]));
      setOtherItems(_orderBy(other, ["category_weight"], ["desc"]));
    }
  }, [line_items, device_id]);

  if (_isEmpty(priority_items)) {
    // hide Orders with only other_items
    return null;
  }

  const title = customer ? `Order: ${customer.display_name}` : "Order";
  return (
    <li className={classes.listSection}>
      <ul className={classes.ul}>
        <Collapse in={visible} timeout="auto" unmountOnExit>
          <ListSubheader className={classes.subheader} data-id={id}>
            {
              <>
                <Typography variant="h6" className={classes.subheaderTitle}>
                  {title}
                </Typography>{" "}
                {to_go ? (
                  <>
                    <span>{"  "}</span>
                    <TogoIcon className={classes.togoIcon} fontSize="large" />
                  </>
                ) : null}
                <ListItemSecondaryAction>
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    className={classes.button}
                    onClick={() => handleDone(id)}
                  >
                    Done
                  </Button>
                </ListItemSecondaryAction>
              </>
            }
          </ListSubheader>
          <Divider className={classes.subheaderDivider} variant="middle" />
          <ListItem inset="true">
            <ListItemText
              className={classes.margin0}
              secondary={`Placed: ${moment(created_at).format("LT")}`}
            ></ListItemText>
            {pickup_at ? (
              <ListItemText
                className={classes.orderDate}
                secondary={`Pickup: ${moment(pickup_at).format("LT")}`}
                secondaryTypographyProps={{ style: { fontWeight: 600 } }}
              ></ListItemText>
            ) : null}
          </ListItem>
          <Divider variant="middle" />
          {priority_items.map((item, idx) => (
            <LineItem key={`${id}-${item.item_id}-${idx}`} id={id} line_item={item} />
          ))}
          {!_isEmpty(other_items) ? (
            <>
              <ListItem button onClick={handleOpen} dense={true} className={classes.foodList} disableRipple>
                {otherOpen ? <ExpandLess /> : <ExpandMore />}
                <ListItemText primary="Other" className={classes.foodTitle} />
              </ListItem>
              <Collapse in={otherOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {other_items.map((other, idx) => (
                    <LineItem key={`${id}-${other.item_id}-${idx}`} id={id} line_item={other} />
                  ))}
                </List>
              </Collapse>
            </>
          ) : null}
        </Collapse>
      </ul>
    </li>
  );
};

Order.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    to_go: PropTypes.bool,
    created_at: PropTypes.string,
    line_items: PropTypes.arrayOf(PropTypes.object),
    customer: PropTypes.shape({ name: PropTypes.string }),
    pickup_at: PropTypes.string,
  }).isRequired,
  onDone: PropTypes.func.isRequired,
  device_id: PropTypes.string.isRequired,
};

export default Order;
